const {
    element: {
        createContext,
    },
} = wp;
export const ConfigurateurContext = createContext('configurateur context');